<template>
  <iColumn
    v-if="editMode"
    data-test="call-room-placeholder"
    width="fill"
    height="hug"
    align="center"
    vertical-align="middle"
  >
    <iText variant="subtle">
      {{ placeholderLabel }}
    </iText>
  </iColumn>
  <CallRoom v-else-if="callRoomProps" v-bind="callRoomProps" />
</template>

<script>
// Edit mode draws a placeholder: the builder's contexts have no pk, so no call can be joined there.
import CallRoom from "@bloglovin/inspire-engine/Components/CallRoom.vue";
import { engineWiringProps } from "%/dynamic-component-editor/helpers/engine-wiring-props";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { hasCompletePk } from "%/dynamic-component-editor/helpers/complete-pk";
import { mergeEngineContexts, engineCurrentUserPk } from "%/dynamic-component-editor/helpers/engine-current-user";
import { Context } from "%/dynamic-component-editor/classes/context-v2";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import JoinLabel from "%/dynamic-component-editor/options/join-label";
import CallRoomWiring from "%/dynamic-component-editor/options/call-room-wiring";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";

export default {
  name: "CallRoomElement",
  components: { CallRoom },
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Call",
    elementGroup: "reusable",
    displayIcon: "mdi:video-outline",
    elementType: "element",
  },
  hidden: true,
  options: [JoinLabel, CallRoomWiring],
  optionBundles: [
    new LayoutWidthHeightOptions(),
    new SpacingOptions(),
  ],
  computed: {
    entityContextName() {
      return this.elementContext?.entityContext ?? "";
    },
    placeholderLabel() {
      return `Call on ${this.entityContextName || "a conversation"}`;
    },
    callRoomProps() {
      if (!this.contextItem || !this.entityType || !this.entityContextName || !hasCompletePk(this.contextItem.entityPkUrlVars)) {
        return null;
      }
      return {
        ...engineWiringProps("CallRoom", this.getOptionValue(CallRoomWiring), `CallRoomElement ${this.identifier}`),
        contexts: mergeEngineContexts(Context.contexts, this.scopedProvidedContexts?.(), {
          [this.entityContextName]: {
            entityType: this.entityType,
            pk: this.contextItem.entityPkUrlVars,
            appName: this.resolvedAppName,
          },
        }, { currentUserPk: engineCurrentUserPk() }),
        entityContext: this.entityContextName,
        appName: this.resolvedAppName,
        joinLabel: this.getOptionValue(JoinLabel) || JoinLabel.defaultValue,
      };
    },
  },
};
</script>
